import { BreakpointTrackerContext } from '@jutro/layout';
import { useHistory } from 'react-router-dom';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import _ from 'lodash';
import React, { useCallback, useContext, useState, useEffect } from 'react';
import { Loader, useModal } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import { UserService } from 'gw-capability-gateway';
import TWIABatchService from "ent-capability-policyportfolio/services/TWIABatchService";
import { CheckboxField } from '@jutro/legacy/components';
import moment from 'moment';
import { format } from 'date-fns';
import metadata from './TransferRequestDetails.metadata.json5';
import messages from '../TWIABatchesLanding/TWIABatchesLanding.messages';
import _TWIADateUtil from "../../../../modules/twia-portals-viewmodel-js/aspects/_TWIADateUtil";
import styles from './TransferRequestDetails.module.scss';

function TransferRequestDetails(props) {
    const breakpoint = useContext(BreakpointTrackerContext);
    const { authHeader } = useAuthentication();
    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useTranslator();
    const [isLoading, setIsLoading] = useState(false);
    const {
        isComponentValid,
        onValidate,
    } = useValidation('TransferRequestDetails');
    const { showAlert, showConfirm } = useModal();
    const [showErrors, setShowErrors] = useState(false);
    const [transferReqVM, updateTransferReqVM] = useState({});
    const [selectedPolicyNumber, setSelectedPolicyNumber] = useState([]);
    const [processDate, setProcessDate] = useState();
    const [effectiveDate, setEffectiveDate] = useState();
    const [prevProducerCode, setPrevProducerCode] = useState([]);
    const [newProducerCode, setNewProducerCode] = useState([]);
    const history = useHistory();
    const {pathname} = history.location;
    const batchCode = pathname.split('/').pop();
    //const { batchCode } = props.match?.params;
    const [requestTable, setRequestTable] = useState([]);
    const [editMode, setEditMode] = useState(false);
    const [statusVal, setStatusVal] = useState();
    const [isEditVisible, setIsEditVisible] = useState(false);
    const [isDeleteDisable, setIsDeleteDisable] = useState(true);
    const [policyRecords, setPolicyRecords] = useState([]);

    useEffect(() => {
        if (onValidate && !_.isNull(isComponentValid)) {
            onValidate(isComponentValid, 'TransferRequestDetails');
        }
    }, [isComponentValid, onValidate]);

    useEffect(() => {
        const batchView = viewModelService.create({}, 'pc', 'edge.capabilities.gateway.bulkproducerchange.dto.TWIABPCBatch_ExtDTO');

        updateTransferReqVM(batchView);
        checkEditBulkProducerChangePermission();
        getProducerCodes();
        getBatchDetail();
        // isEditVisibleForBatch();
    }, []);

    const checkEditBulkProducerChangePermission = useCallback(async () => {
        const permissionDTO = {
            permission: 'editbulkproducerchange_ext'
        };

        const permissionCheckPromise = await UserService.hasUserSystemPermission(permissionDTO, authHeader);

        _.set(transferReqVM, 'hasEditBulkProducerChangePermission', permissionCheckPromise);
        updateTransferReqVM(transferReqVM);

        return permissionCheckPromise;
    }, [authHeader, transferReqVM]);

    const getProducerCodes = useCallback(async () => {
        const producerCodesPromise = UserService.getAvailableProducerCodesForCurrentUser(authHeader);

        producerCodesPromise.then((producerCodesResponse) => {
            _.set(transferReqVM, 'producerCode', producerCodesResponse);
            updateTransferReqVM(transferReqVM);
        });
    }, [authHeader, transferReqVM]);

    const getStatus = useCallback((statusCode) => {
        const typelist = viewModelService?.productMetadata?.get('pc').types.getTypelist('BPCBatchStatus_Ext');
        const formattedTypes = typelist?.codes.map((code) => ({
            code: code.code,
            name: translator({ id: code.name })
        }));

        const matchingType = formattedTypes?.find((type) => type.code === statusCode);

        setStatusVal(matchingType.name);

        return matchingType ? matchingType.name : null;
    }, [translator, viewModelService?.productMetadata]);

    const isEditVisibleForBatch = useCallback((status) => {
        if (!_.isUndefined(transferReqVM) || !_.isUndefined(transferReqVM.value)) {
            if (status === 'pendingapproval') {
                setIsEditVisible(true);
            } else {
                setIsEditVisible(false);
            }
        }
    }, [transferReqVM]);


    const processTransferRequest = useCallback((requests) => {

        const requestMap = requests.map(req => ({
            checked: false,
            policyNumber: req.policyNumber || '',
            accountNumber: req.accountNumber || '',
            primaryInsured_Ext: req.primaryInsured_Ext || '',
            policyEffectiveDate_Ext: req.policyEffectiveDate_Ext ? format(new Date(req.policyEffectiveDate_Ext), 'MM/dd/yyyy') : '',
            policyStatus_Ext: req.policyStatus_Ext || '',
            status: req.status || '',
            message: req.message || ''
        }));

        setRequestTable(requestMap);

    }, []);

    const getBatchDetail = useCallback(async () => {
        await TWIABatchService.getBatchByCode(batchCode, authHeader).then((batch) => {
            transferReqVM.publicID = batch.publicID;
            transferReqVM.batchCode = batch.batchCode;
            transferReqVM.targetDate = new Date(batch.targetDate);
            transferReqVM.effectiveDate_Ext = new Date(batch.effectiveDate_Ext);
            transferReqVM.oldProducerCode = batch.oldProducerCode;
            transferReqVM.newProducerCode = batch.newProducerCode;
            transferReqVM.status = batch.status;
            transferReqVM.policyRecords = batch.policyRecords;
            getStatus(batch.status)
            updateTransferReqVM(transferReqVM);
            processTransferRequest(batch.policyRecords);
            setPolicyRecords(batch.policyRecords);
            setProcessDate(transferReqVM.targetDate);
            setEffectiveDate(transferReqVM.effectiveDate_Ext);
            setPrevProducerCode(batch.oldProducerCode);
            setNewProducerCode(batch.newProducerCode);
            isEditVisibleForBatch(batch.status);
        });
    }, [authHeader, batchCode, getStatus, isEditVisibleForBatch, processTransferRequest, transferReqVM]);

    const onBackClick = () => {
        history.push('/batches');
    };

    const deletePolicyBtnDisabled = useCallback(() => {
        if (selectedPolicyNumber.length === 0) {
            setIsDeleteDisable(true);
        }
    }, [selectedPolicyNumber]);

    const editTransferRequest = useCallback(() => {
        setEditMode(true);
        deletePolicyBtnDisabled();
    }, [deletePolicyBtnDisabled]);


    const getCheckedBatchCodes = (e, item) => {
        const isChecked = !item.checked;
        
        item.checked = isChecked;

        if (isChecked) {
            setSelectedPolicyNumber(prev => [...prev, item.policyNumber]);
        } else {
            setSelectedPolicyNumber(prev => prev.filter(policyNumber => policyNumber !== item.policyNumber));
        }
    };

    /**
     * Need function declaration, instead of arrow function
     * due to when this function can be invoked/resolved
     * so useState works properly.
     * DE19538
     */
    function getCheckBox(item, index) {
        return (
            <CheckboxField
                name={item.policyNumber}
                id={item.policyNumber}
                value={item.checked}
                onValueChange={e => getCheckedBatchCodes(e, item, index)}
            />
        );
    }

    const writeValue = useCallback((value, path) => {
        if (path === 'targetDate') {
            setProcessDate(value);

            return;
        }

        if (path === 'effectiveDate_Ext') {
            setEffectiveDate(value);

            return;
        }

        _.set(transferReqVM, path, value);
        updateTransferReqVM(transferReqVM);
    }, [transferReqVM, updateTransferReqVM]);

    const onSaveChanges = async () => {

        if (!isComponentValid) {
            setShowErrors(true);

            return false;
        }

        const targetDate = moment(_.get(transferReqVM, 'targetDate'));
        const effDate = moment(_.get(transferReqVM, 'effectiveDate_Ext'));
        const todayYear = new Date(_TWIADateUtil.beginOfToday()).getFullYear();
        const currentDate = moment();

        _.set(transferReqVM, 'targetDate', targetDate);
        _.set(transferReqVM, 'effectiveDate_Ext', effDate);
        updateTransferReqVM(transferReqVM);

        if (targetDate.isBefore(currentDate, 'day')) {
            showAlert({
                title: translator(messages.newBatchRequest),
                message: translator(messages.newBatchProcessDateWarning),
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: translator(messages.close)
            });

            return;
        }

        if (effDate.year() < todayYear) {
            showAlert({
                title: translator(messages.transferRequestDetail),
                message: translator(messages.newBatchEffectiveDateWarning),
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: translator(messages.close)
            });

            return;
        }

        try {
            const res = await TWIABatchService.createOrUpdateBatch(transferReqVM, authHeader);
            
            setPolicyRecords(res.policyRecords);

            showConfirm({
                title: translator(messages.transferRequestDetail),
                message: translator(messages.transferReqSuccessMsg),
                status: 'warning',
                icon: 'gw-help-outline',
                messageProps: {
                    ok: translator(messages.yes)
                },
            })
                .then((result) => {
                    if (result === 'confirm') {
                        setEditMode(false);
                    }
                })
        } catch (err) {

            const errorMessage = _.split(err.baseError, 'ErrorMessage: ')[2]?.trim();

            if (errorMessage) {
                showAlert({
                    title: 'Error',
                    message: errorMessage,
                    status: 'error',
                    icon: 'mi-error-outline',
                    confirmButtonText: translator(messages.close)
                })
            } else {
                showAlert({
                    title: 'Error',
                    message: translator(messages.unableToCancel),
                    status: 'error',
                    icon: 'mi-error-outline',
                    confirmButtonText: translator(messages.close)
                })
            }
        }
    };


    const onDelete = useCallback(async () => {
        const updatedRequestTable = requestTable.filter(
            item => !selectedPolicyNumber.includes(item.policyNumber)
        );

        const updatedPolicyRecords = policyRecords.filter(
            item => !selectedPolicyNumber.includes(item.policyNumber)
        );
    
        setRequestTable(updatedRequestTable);
        setPolicyRecords(policyRecords);
        _.set(transferReqVM, 'policyRecords', updatedPolicyRecords);
        updateTransferReqVM(transferReqVM);
        setSelectedPolicyNumber([]);
    }, [policyRecords, requestTable, selectedPolicyNumber, transferReqVM]);


    const onCancel = async () => {

        setEditMode(false);
    };

    const overrideProps = {
        '@field': {
            // apply to all fields
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        requestId: {
            label: translator(messages.requestId),
            showRequired: true,
            value: batchCode,
        },
        processDate: {
            label: translator(messages.processDate),
            showRequired: true,
            value: processDate,
            readOnly: !editMode
        },
        effectiveDate: {
            label: translator(messages.effectiveDate),
            showRequired: true,
            value: effectiveDate,
            readOnly: !editMode
        },
        prevProducerCode: {
            showRequired: true,
            value: prevProducerCode
        },
        newProducerCode: {
            showRequired: true,
            value: newProducerCode
        },
        status: {
            label: translator(messages.status),
            showRequired: true,
            value: statusVal,
        },
        reportTableGrid: {
            data: requestTable
        },
        editContainer: {
            visible: isEditVisible && !editMode
        },
        buttonsContainer: {
            visible: editMode
        },
        checkbox: {
            visible: editMode
        },
        deleteButton: {
            disabled: selectedPolicyNumber.length === 0
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onBackClick,
            onDelete,
            getCheckBox,
            editTransferRequest,
            onSaveChanges,
            onCancel
        },

    }

    return (
        <Loader loaded={!isLoading}>
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={transferReqVM}
                overrideProps={overrideProps}
                onModelChange={updateTransferReqVM}
                onValueChange={writeValue}
                showErrors={showErrors}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
                onValidationChange={onValidate}
            />
        </Loader>
    );
}

export default TransferRequestDetails;